export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-apple-d881362d009b94d3fbad912177e85744.svg";